/**
 * Implements a Bootstrap Tooltip
 */

import Marionette from "backbone.marionette";

class Tooltip extends Marionette.Behavior {
  ui() {
    return {
      tooltip: "[data-toggle=tooltip]",
    };
  }

  defaults() {
    return {
      opts: {
        container: "body",
        html: false,
        placement: "auto top",
        trigger: "hover",
        delay: {
          show: 250,
          hide: 100,
        },
      },
    };
  }

  initialize() {
    // debounce view render event
    this.listenTo(this.view, "render", _.debounce(this._onViewRender, 200));

    // merge defaults and user options
    _.defaults(this.options.opts, this.defaults.opts);
  }

  _onViewRender() {
    // enable bootstrap tooltip, but not before making sure the tooltip
    // function exists
    if (_.isFunction(this.ui.tooltip.tooltip)) {
      this.ui.tooltip.tooltip(this.options.opts);
    }
  }
}

export { Tooltip as default };
